import { CloseOutlined, PlusOutlined } from "@ant-design/icons";
import {
  Button,
  Col,
  Divider,
  Empty,
  Form,
  Input,
  message,
  Modal,
  Popconfirm,
  Result,
  Row,
  Select,
  Space,
  Spin,
  Switch,
} from "antd";
import { useForm } from "antd/es/form/Form";
import TextArea from "antd/es/input/TextArea";
import ModalConfirm from "app/components/ConfirmExit";
import EditorJSCustom from "app/components/EditorJSCustom/EditorJSCustom";
import SunEditorCustom from "app/components/SunEditorCustom";
import TinyEditor from "app/components/TinyEditor/TinyEditor";
import { APP_SETTINGS, EEditorType, FORM_MODE } from "constant";
import { PAGE_ROUTE } from "constant/routes/page";
import { useGetParamsUrl, useHandleSubmitApi } from "hook";
import {
  ESourceTagRelation,
  ICreatePostInputMode,
  IGetCatePostOutputModel,
  IPostDetailOutputModel,
  TTagOutputModel,
} from "interfaces";
import { ReactNode, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { PostServices } from "services";
import { TagService } from "services/tag";
import { FormDataUtil } from "utils/form";
import { OtherUtil } from "utils/other";
import uploadUtil from "utils/upload";
import InventoryImageForm from "../../Inventory/InventoryForm/InventoryImageForm.presenter";
import HistoryPostForm from "./HistoryPostForm.presenter";
// const Diff = require("diff");

type P_Props = {
  onClose: () => void;
};

interface IStatePostForm {
  title: string;
  status: boolean;
  content: string;
  catePostId: string | undefined;
  titleSeo: string;
  descSeo: string;
  slugSeo: string;
  allowSeo: boolean;
  // postImage: UploadFile<any> | null | string;
  postImage: any;
  isOutstanding: boolean;
  isMainTopic: boolean;
  isMainOutstandingTopic: boolean;
  keywords: string[];
}

const PostFormPresenter = (props: P_Props) => {
  const [form] = useForm();
  const navigate = useNavigate();
  const pathName = window.location.pathname;
  const mode = pathName === PAGE_ROUTE.ADM_POST_CREATE ? FORM_MODE.CREATE : FORM_MODE.EDIT;
  const dataParams = useGetParamsUrl<{ id: string }>();
  const [visibleHistory, setVisibleHistory] = useState<string | null>(null);

  const initialValues: IStatePostForm = {
    title: "",
    catePostId: undefined,
    status: true,
    content: "",
    titleSeo: "",
    descSeo: "",
    slugSeo: "",
    allowSeo: false,
    postImage: null,
    isOutstanding: false,
    isMainTopic: false,
    isMainOutstandingTopic: false,
    keywords: [],
  };
  const [postContent, setPostContent] = useState("");
  const [shortDescription, setShortDescription] = useState("");
  const [visibleExit, setVisibleExit] = useState(false);
  const [formValues, setFormValues] = useState<IStatePostForm>(initialValues);
  const [optCatePost, setOptCatePost] = useState<IGetCatePostOutputModel[]>([]);

  const [visibleModalMainTopic, setVisibleModalMainTopic] = useState<IPostDetailOutputModel | null>(null);
  const [visibleModalMainTopicOutstanding, setVisibleModalMainTopicOutstanding] =
    useState<IPostDetailOutputModel | null>(null);
  const [tags, setTags] = useState<TTagOutputModel[]>([]);
  const [inputTag, setInputTag] = useState("");

  useEffect(() => {
    getListCatePost();
    handleFetchTag();

    //eslint-disable-next-line
  }, []);

  const [getListCatePost, loadingCatePost] = useHandleSubmitApi(async () => {
    const dataRes = await PostServices.getCatePost();
    if (dataRes) {
      if (dataRes.data && dataRes.data.length) {
        setOptCatePost(dataRes.data);
      }
    }
  });

  useEffect(() => {
    if (dataParams && mode === FORM_MODE.EDIT) {
      handleFetchDetail(dataParams.id, () => {});
    }

    //eslint-disable-next-line
  }, [dataParams]);

  const [handleFetchDetail, loadingDetail, isError] = useHandleSubmitApi(async (id: string) => {
    const dataRes = await PostServices.getDetailPost({ id: id });

    if (dataRes) {
      bindDataDetail(dataRes.data);
    }
  });

  const [handleFetchTag, loadingTag] = useHandleSubmitApi(async () => {
    const dataRes = await TagService.getListTag({ source: ESourceTagRelation.E_MAGAZINE });
    if (dataRes) {
      setTags(dataRes.data);
    }
  });

  const [handleCreateTag, loadingCreateTag] = useHandleSubmitApi(
    async (name: string) => {
      const dataRes = await TagService.createTag({ name, source: ESourceTagRelation.E_MAGAZINE });
      if (dataRes) {
        await handleFetchTag();
        message.success("Tạo mới từ khoá thành công");

        handleChangeFormValues({ keywords: [...(formValues.keywords || []), dataRes.data.id] } as any);
      }
    },
    () => {
      message.error("Tạo mới từ khoá thất bại");
    }
  );

  const [handleRemoveTag, loadingRemoveTag] = useHandleSubmitApi(
    async (tagId: string) => {
      if (!tagId) return message.info("Có lỗi xảy ra, vui lòng thử lại sau!");
      const dataRes = await TagService.deleteTag(tagId, { source: ESourceTagRelation.E_MAGAZINE });
      if (dataRes) {
        await handleFetchTag();
        message.success("Xoá từ khoá thành công!");

        handleChangeFormValues({
          keywords: [...(formValues.keywords || [])?.filter((keyword) => keyword !== tagId)],
        } as any);
      }
    },
    () => {
      message.error("Từ khoá đã được sử dụng!");
    }
  );

  const bindDataDetail = (data: IPostDetailOutputModel) => {
    if (data) {
      const initialValuesEdit: IStatePostForm = {
        title: data.title,
        status: data.status,
        content: data.content,
        allowSeo: data.allowSeo,
        titleSeo: data.titleSeo,
        descSeo: data.descSeo,
        slugSeo: data.slugSeo,
        catePostId: data.catePostId,
        postImage: null,
        isOutstanding: data.isOutstanding,
        isMainTopic: data.isMainTopic,
        isMainOutstandingTopic: data.isMainOutstandingTopic,
        keywords: data.keywords?.map((k) => k.id),
      };

      if (data.media) {
        initialValuesEdit.postImage = [
          {
            uid: data.id,
            name: data.media.title,
            url: data.media.path,
            status: "done",
            originId: data.media.id,
          },
        ];
      }

      setPostContent(data.content);
      setShortDescription(data.shortDescription);
      setFormValues(initialValuesEdit);
      form.setFieldsValue(initialValuesEdit);
    }
  };

  const handleChangeFormValues = (values: typeof initialValues) => {
    setFormValues((prevData) => ({ ...prevData, ...values }));
    form.setFieldsValue({ ...values });
  };

  const handleSubmit = async (values: IStatePostForm) => {
    // if (!postContent || !shortDescription) {
    //   return message.error("Vui lòng nhập nội dung");
    // }

    const dataPost: ICreatePostInputMode = {
      catePostId: formValues.catePostId || "",
      title: formValues.title,
      status: formValues.status,
      allowSeo: formValues.allowSeo,
      content: postContent,
      titleSeo: formValues.titleSeo,
      descSeo: formValues.descSeo,
      isOutstanding: formValues.isOutstanding,
      isMainTopic: formValues.isMainTopic,
      isMainOutstandingTopic: !!formValues.isOutstanding ? formValues.isMainOutstandingTopic : false,
      shortDescription: shortDescription,
      keywords: formValues.keywords,
    };

    if (!!dataPost["isMainTopic"]) {
      if (!dataPost.catePostId) return;

      const post = await checkMainTopic(dataPost.catePostId, dataParams?.id);
      if (!!post && !visibleModalMainTopic) return setVisibleModalMainTopic(post);
    }

    if (!!dataPost["isOutstanding"] && !!dataPost["isMainOutstandingTopic"]) {
      const post = await checkMainTopicOutstanding(dataParams?.id);
      if (!!post && !visibleModalMainTopicOutstanding) return setVisibleModalMainTopicOutstanding(post);
    }

    setVisibleModalMainTopic(null);
    setVisibleModalMainTopicOutstanding(null);

    if (!!values["postImage"]?.length) {
      dataPost["mediaId"] = values["postImage"][0]?.originId;
    }

    console.log(255, dataPost["content"]);
    if (dataPost["content"]) {
      dataPost["content"] = await uploadUtil.handleImageUpload(dataPost["content"]);
      console.log(257, dataPost["content"]);
    }

    const formData = FormDataUtil.convertJsonToFormData(dataPost, {
      handelObjectInArr: (input) => {
        const temp = FormDataUtil.transformObjectFormData({
          mainKey: input.mainKey,
          data: input.data,
          mainIdx: input.mainIdx,
          customKeyForm: ({ mainKey, key, mainIdx }) => {
            return `${mainKey}[${mainIdx}][${key}]`;
          },
        });

        return temp;
      },
    });

    if (mode === FORM_MODE.CREATE) {
      await createFormData(formData);
    } else if (mode === FORM_MODE.EDIT) {
      await updateFormData(formData);
    }
  };

  const [createFormData, loadingCreate] = useHandleSubmitApi(async (formData: FormData) => {
    const dataRes = await PostServices.createPost(formData);
    if (dataRes) {
      message.success("Tạo bài viết thành công");
      navigate(PAGE_ROUTE.ADM_POST);
    }
  });

  const [updateFormData, loadingUpdate] = useHandleSubmitApi(async (formData: FormData) => {
    if (dataParams && dataParams.id) {
      const dataRes = await PostServices.updatePost(formData, dataParams.id);
      if (dataRes) {
        message.success("Cập nhật bài viết thành công");
        navigate(PAGE_ROUTE.ADM_POST);
      }
    }
  });

  const [checkMainTopic, loadingMainTopic] = useHandleSubmitApi(async (catePostId: string, postId?: string) => {
    const dataRes = await PostServices.checkMainTopic({ catePostId, postId });
    return dataRes?.data;
  });

  const [checkMainTopicOutstanding, loadingMainTopicOutstanding] = useHandleSubmitApi(async (postId?: string) => {
    const dataRes = await PostServices.checkMainTopicOutstanding({ postId });
    return dataRes?.data;
  });

  const renderFeedBack = (conditions: {
    visible: boolean;
    title: ReactNode;
    loading: boolean;
    onClick: () => void;
    onClose: () => void;
  }) => {
    const { visible, title, loading, onClick, onClose } = conditions;
    return (
      <Modal open={visible} footer={<></>}>
        <Result
          status="warning"
          title={title}
          extra={
            <>
              <Button type="primary" key="console" onClick={onClick} loading={loading}>
                Đồng ý
              </Button>
              <Button onClick={onClose}>Huỷ bỏ</Button>
            </>
          }
        />
      </Modal>
    );
  };

  const loading = loadingCreate || loadingUpdate;
  const loadingTags = loadingRemoveTag || loadingCreateTag || loadingTag;

  return (
    <>
      <HistoryPostForm id={visibleHistory} onClose={() => setVisibleHistory(null)} />

      <div className="layout-form">
        {!!visibleModalMainTopic &&
          renderFeedBack({
            visible: !!visibleModalMainTopic,
            title: (
              <span>
                Danh mục hiện đã có bài viết nổi bật{" "}
                <b
                  style={{ cursor: "pointer" }}
                  onClick={() => window.open(`${PAGE_ROUTE.ADM_POST_EDIT}?id=${visibleModalMainTopic.id}`)}
                >
                  {visibleModalMainTopic.title}
                </b>{" "}
                <br /> Bạn có chắc chắn muốn thay đổi
              </span>
            ),
            loading: loadingMainTopic,
            onClick: () => handleSubmit(formValues),
            onClose: () => setVisibleModalMainTopic(null),
          })}

        {!!visibleModalMainTopicOutstanding &&
          renderFeedBack({
            visible: !!visibleModalMainTopicOutstanding,
            // title: "Danh mục nổi bật đã có bài viết đại diện, bạn có chắc chắn muốn thay đổi",
            title: (
              <span>
                Danh mục nổi bật đã có bài viết đại diện{" "}
                <b
                  style={{ cursor: "pointer" }}
                  onClick={() => window.open(`${PAGE_ROUTE.ADM_POST_EDIT}?id=${visibleModalMainTopicOutstanding.id}`)}
                >
                  {visibleModalMainTopicOutstanding.title}
                </b>{" "}
                <br /> Bạn có chắc chắn muốn thay đổi
              </span>
            ),
            loading: loadingMainTopicOutstanding,
            onClick: () => handleSubmit(formValues),
            onClose: () => setVisibleModalMainTopicOutstanding(null),
          })}

        {isError ? (
          <Empty style={{ paddingTop: "20%" }} />
        ) : loadingDetail ? (
          <div className="layout-form__loading">
            <Spin size="large" />
          </div>
        ) : (
          <div className="layout-form__content">
            <div className="layout-form__title">
              {mode === FORM_MODE.CREATE ? "Tạo bài viết mới" : "Chỉnh sửa bài viết"}
            </div>
            <Form
              form={form}
              className="w_100"
              layout="vertical"
              initialValues={formValues}
              onValuesChange={(values) => handleChangeFormValues(values)}
            >
              <Row gutter={[20, 20]}>
                <Col span={12}>
                  <Form.Item
                    name={"title"}
                    label="Tiêu đề"
                    rules={[{ required: true, message: "Vui lòng nhập tiêu đề" }]}
                  >
                    <Input size="large" placeholder="Nhập tiêu đề" maxLength={150} showCount />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    name={"catePostId"}
                    label="Danh mục"
                    rules={[{ required: true, message: "Vui lòng chọn danh mục" }]}
                  >
                    <Select
                      size="large"
                      placeholder={"Chọn danh mục"}
                      className="w_100"
                      options={optCatePost.map((data) => ({
                        label: data["name"],
                        value: data["id"],
                      }))}
                      disabled={loadingCatePost}
                    />
                  </Form.Item>
                </Col>

                <Col span={12}>
                  <Row>
                    <Col span={12}>
                      <div className="d-flex items-center">
                        <Form.Item label={"Trạng thái"}>
                          <Form.Item name="status" label={"Trạng thái"} valuePropName="checked" noStyle>
                            <Switch />
                          </Form.Item>
                          <span className="ml_0-5">{!!formValues?.status ? "Hiển thị" : "Ẩn"}</span>
                        </Form.Item>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="d-flex items-center">
                        <Form.Item label={"Chủ đề nổi bật (isOutstanding)"}>
                          <Form.Item name="isOutstanding" label={"Chủ đề nổi bật"} valuePropName="checked" noStyle>
                            <Switch />
                          </Form.Item>
                          <span className="ml_0-5">{!!formValues?.isOutstanding ? "Hiển thị" : "Ẩn"}</span>
                        </Form.Item>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="d-flex items-center">
                        <Form.Item label={"Đại diện danh mục (isMainTopic)"}>
                          <Form.Item name="isMainTopic" label={"Đại diện chủ đề"} valuePropName="checked" noStyle>
                            <Switch />
                          </Form.Item>
                          <span className="ml_0-5">{!!formValues?.isMainTopic ? "Hiển thị" : "Ẩn"}</span>
                        </Form.Item>
                      </div>
                    </Col>
                    {formValues["isOutstanding"] && (
                      <Col span={12}>
                        <div className="d-flex items-center">
                          <Form.Item label={"Đại diện chủ đề nổi bật (isMainOutstandingTopic)"}>
                            <Form.Item
                              name="isMainOutstandingTopic"
                              label={"Đại diện chủ đề nổi bật"}
                              valuePropName="checked"
                              noStyle
                            >
                              <Switch />
                            </Form.Item>
                            <span className="ml_0-5">{!!formValues?.isMainOutstandingTopic ? "Hiển thị" : "Ẩn"}</span>
                          </Form.Item>
                        </div>
                      </Col>
                    )}
                  </Row>
                </Col>
                <Col span={12}>
                  <div className="layout-form__label-required">Ảnh đại diện bài viết</div>
                  <Form.Item
                    name={"postImage"}
                    rules={[
                      {
                        required: true,
                        message: "Vui lòng chọn ảnh đại diện!",
                      },
                    ]}
                  >
                    {/* <FileUpload
                      // value={form.getFieldValue("content")}
                      onChange={(value) => {
                        form.setFieldValue("postImage", value);
                      }}
                      // showUploadList={false}
                    /> */}

                    <InventoryImageForm
                      limit={1}
                      value={form.getFieldValue("postImage")}
                      onChange={(value) => form.setFieldValue("postImage", value)}
                    />
                  </Form.Item>
                </Col>

                <Col span={24}>
                  <div className="layout-form__label-required">Mô tả ngắn</div>
                  {false && (
                    <div style={{ border: "2px solid #eee", borderRadius: 8, padding: "20px 0" }}>
                      <EditorJSCustom
                        content={postContent}
                        onChange={(value) => {
                          setShortDescription(value);
                        }}
                      />
                    </div>
                  )}

                  {APP_SETTINGS.EDITOR_TYPE === EEditorType.SUN_EDITOR && (
                    <SunEditorCustom
                      content={shortDescription}
                      onChange={(value) => {
                        setShortDescription(value);
                      }}
                      height={"300px"}
                    />
                  )}

                  {APP_SETTINGS.EDITOR_TYPE === EEditorType.TINY_MCE && (
                    <TinyEditor
                      content={shortDescription}
                      onChange={(value) => {
                        setShortDescription(value);
                      }}
                      height={300}
                    />
                  )}
                </Col>

                <Col span={24}>
                  <div className="layout-form__label-required">Nội dung bài viết</div>
                  {APP_SETTINGS.EDITOR_TYPE === EEditorType.SUN_EDITOR && (
                    <SunEditorCustom
                      content={postContent}
                      onChange={(value) => {
                        setPostContent(value);
                      }}
                    />
                  )}

                  {APP_SETTINGS.EDITOR_TYPE === EEditorType.TINY_MCE && (
                    <TinyEditor
                      content={postContent}
                      onChange={(value) => {
                        setPostContent(value);
                      }}
                    />
                  )}
                </Col>

                <Col span={24}>
                  <div className="d-flex justify-space-between">
                    <span className="layout-form__title">SEO</span>
                    <div className="d-flex items-center">
                      <span className="mr_0-5">Chỉnh sửa SEO</span>
                      <Form.Item noStyle name="allowSeo" valuePropName="checked">
                        <Switch />
                      </Form.Item>
                    </div>
                  </div>
                  <Form.Item
                    name={"titleSeo"}
                    label={"Tiêu đề trang"}
                    rules={[
                      {
                        required: formValues["allowSeo"],
                        message: "Vui lòng nhập tiêu đề!",
                      },
                    ]}
                  >
                    <Input size="large" maxLength={150} showCount placeholder="Nhập tiêu đề" />
                  </Form.Item>

                  <Form.Item name={"keywords"} label={"Từ khoá bài viết"}>
                    {/* <TagsInput
                        value={formValues["keywords"]}
                        name="fruits"
                        placeHolder="Nhập từ khoá"
                        disabled={loadingTag}
                      /> */}

                    <Select
                      mode="multiple"
                      className="w_100"
                      size="large"
                      placeholder="Chọn từ khoá"
                      loading={loadingTags}
                      disabled={loadingTags}
                      filterOption={(input, option) =>
                        OtherUtil.convertSlugUnicode(option?.label ?? "")
                          .toLowerCase()
                          .includes(OtherUtil.convertSlugUnicode(input).toLowerCase())
                      }
                      onSelect={(value) => {
                        if (tags?.find((t) => t.id === value)) return;
                        handleCreateTag(value);
                      }}
                      dropdownRender={(menu: any) => (
                        <>
                          {menu}
                          <Divider style={{ margin: "8px 0" }} />

                          <Space style={{ padding: "0 8px 4px" }}>
                            <Input
                              placeholder="Nhập từ khoá"
                              onChange={(e) => setInputTag(e.target.value)}
                              onKeyDown={(e) => e.stopPropagation()}
                              disabled={loadingTags}
                            />
                            <Button
                              loading={loadingTags}
                              type="text"
                              icon={<PlusOutlined />}
                              onClick={() => handleCreateTag(inputTag)}
                            >
                              Thêm mới
                            </Button>
                          </Space>
                        </>
                      )}
                      optionRender={(option) => (
                        <div className="d-flex items-center justify-space-between" style={{ height: "2rem" }}>
                          <p>{option.data.label}</p>

                          <Popconfirm
                            title="Xoá từ khoá?"
                            description="Bạn có chắc chắn muốn xoá từ khoá này?"
                            okText="Xác nhận"
                            cancelText="Không"
                            onCancel={(e) => {
                              e?.stopPropagation();
                              e?.preventDefault();
                            }}
                            onConfirm={(e) => {
                              e?.stopPropagation();
                              e?.preventDefault();
                              handleRemoveTag(option?.value as string);
                            }}
                          >
                            <Button
                              className="mr_1"
                              color="danger"
                              variant="dashed"
                              onClick={(e) => {
                                e.stopPropagation();
                                e.preventDefault();
                              }}
                            >
                              <CloseOutlined style={{ color: "red" }} />
                              Gỡ bỏ
                            </Button>
                          </Popconfirm>
                        </div>
                      )}
                      options={tags.map((item) => ({ label: item.name, value: item.id }))}
                    />
                  </Form.Item>

                  <Form.Item
                    name={"descSeo"}
                    label={"Mô tả"}
                    rules={[
                      {
                        required: formValues["allowSeo"],
                        message: "Vui lòng nhập mô tả!",
                      },
                    ]}
                  >
                    <TextArea placeholder="Nhập mô tả" rows={4} maxLength={500} showCount />
                  </Form.Item>

                  <Form.Item name={"slugSeo"} label={"Đường dẫn"}>
                    <Input size="large" maxLength={150} showCount placeholder="Nhập đường dẫn" disabled />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </div>
        )}

        {!isError && (
          <div className="layout-form__footer">
            {!!dataParams?.id && (
              <Button size="large" className="btn btn-outline mr_1" onClick={() => setVisibleHistory(dataParams?.id)}>
                Lịch sử thay đổi
              </Button>
            )}
            <div className="ml-auto">
              <Button
                size="large"
                className="btn btn-outline mr_1"
                style={{ width: 100 }}
                onClick={() => setVisibleExit(true)}
              >
                Hủy
              </Button>
              <Button
                size="large"
                className="btn"
                style={{ width: 100 }}
                loading={loading}
                disabled={loadingDetail}
                onClick={() => form.validateFields().then(handleSubmit)}
              >
                Lưu
              </Button>
            </div>
          </div>
        )}
      </div>

      {visibleExit && (
        <ModalConfirm
          visible={visibleExit}
          title="Bạn có chắc chắn muốn thoát?"
          cancel={() => setVisibleExit(false)}
          confirm={() => {
            setVisibleExit(false);
            navigate(PAGE_ROUTE.ADM_POST);
            props.onClose();
          }}
        />
      )}
    </>
  );
};

export default PostFormPresenter;
